import { Link } from 'react-router-dom';

export default function SEOSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="text-xs font-semibold uppercase tracking-widest text-foreground-500">
            SEO Resources
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-8">
              Why You Need a
              <br />
              <span className="italic font-semibold">CSSBuy Spreadsheet</span>
            </h2>
            <div className="prose-custom space-y-5 text-foreground-700 leading-relaxed">
              <p>
                Shopping through agents like CSSBuy opens access to thousands of products across hundreds of
                Chinese marketplaces, but finding quality items without a curated <strong>CSSBuy spreadsheet</strong> can
                be overwhelming. A well-maintained spreadsheet organizes verified product links by category,
                saving you hours of manual searching through TaoBao, Weidian, and 1688 listings.
              </p>
              <p>
                The best <strong>CSSBuy spreadsheet</strong> for 2026 includes direct product links, QC photos,
                price comparisons, sizing references, and seller ratings &mdash; all updated regularly to ensure
                every link still works. Whether you are looking for the latest sneaker releases, budget
                streetwear essentials, or premium designer alternatives, a reliable spreadsheet is the
                difference between a smooth haul and a frustrating shopping experience.
              </p>
              <p>
                Our curated collection of <strong>CSSBuy finds</strong> is organized across 15 product
                categories, from shoes and hoodies to accessories and perfumes. Each category page on
                kaspreadsheet.com features live spreadsheet links that take you directly to product listings,
                complete with community reviews and sizing recommendations from experienced shoppers in the
                agent community.
              </p>
            </div>

            <div className="mt-8">
              <Link
                to="/cssbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-300 text-foreground-700 font-medium text-sm hover:border-foreground-500 hover:text-foreground-950 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Read SEO Guide
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 content-start">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">500+</div>
              <div className="text-sm text-foreground-600 mt-2">Spreadsheet Links</div>
            </div>
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">100+</div>
              <div className="text-sm text-foreground-600 mt-2">Daily Updates</div>
            </div>
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">99%</div>
              <div className="text-sm text-foreground-600 mt-2">User Satisfaction</div>
            </div>
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">15</div>
              <div className="text-sm text-foreground-600 mt-2">Product Categories</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}